import type {
  LalKitabKundliRequest,
  LalKitabKundliResponse,
  PlanetEffect,
  ActiveRemedy,
  DetectedDebt,
} from "@ishvaram/api-client";
export type {
  LalKitabKundliRequest,
  LalKitabKundliResponse,
  PlanetEffect,
  ActiveRemedy,
  DetectedDebt,
};
import { apiRequest } from "./_fetch";

export async function calculateLalKitabKundli(
  data: LalKitabKundliRequest
): Promise<LalKitabKundliResponse> {
  return apiRequest<LalKitabKundliResponse>("/lal-kitab-kundli", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}
